// extracted by mini-css-extract-plugin
module.exports =  {"container":"sXCoKedB6vsU1Ja1KnkC"};